/**
 * @flow
 * @relayHash d1ba3a6230dcc7707b327bc2f1d6c47b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Topic_topic$ref = any;
export type TopicEditInput = {
  id: string,
  name: string,
  slug?: ?string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  hidden?: ?boolean,
  clientMutationId?: ?string,
};
export type TopicEditMutationVariables = {|
  input: TopicEditInput
|};
export type TopicEditMutationResponse = {|
  +TopicEdit: ?{|
    +topic: ?{|
      +$fragmentRefs: Topic_topic$ref
    |}
  |}
|};
export type TopicEditMutation = {|
  variables: TopicEditMutationVariables,
  response: TopicEditMutationResponse,
|};
*/


/*
mutation TopicEditMutation(
  $input: TopicEditInput!
) {
  TopicEdit(input: $input) {
    topic {
      ...Topic_topic
      id
    }
  }
}

fragment Topic_topic on Topic {
  id
  name
  hidden
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TopicEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "TopicEditInput!"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TopicEditMutation",
  "id": null,
  "text": "mutation TopicEditMutation(\n  $input: TopicEditInput!\n) {\n  TopicEdit(input: $input) {\n    topic {\n      ...Topic_topic\n      id\n    }\n  }\n}\n\nfragment Topic_topic on Topic {\n  id\n  name\n  hidden\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TopicEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "TopicEdit",
        "storageKey": null,
        "args": v1,
        "concreteType": "TopicEditPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "topic",
            "storageKey": null,
            "args": null,
            "concreteType": "Topic",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "Topic_topic",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TopicEditMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "TopicEdit",
        "storageKey": null,
        "args": v1,
        "concreteType": "TopicEditPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "topic",
            "storageKey": null,
            "args": null,
            "concreteType": "Topic",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hidden",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '88a3881a9688eb7f53f80c1f5269b97a';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TopicEditMutation.graphql.js